module.exports = __webpack_public_path__ + "img/nav-category-eternity.7a82143.svg";